import { useEffect, useState } from "react";
import PayTRIframe from "../components/PayTRIframe";

const PaymentPage = () => {
  const [iframeToken, setIframeToken] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("iframeToken");
    if (token) setIframeToken(token);
  }, []);

  return (
    <div className="mt-10 max-w-3xl mx-auto">
      {iframeToken ? (
        <PayTRIframe iframeToken={iframeToken} />
      ) : (
        <p>Yönlendiriliyor...</p>
      )}
    </div>
  );
};

export default PaymentPage;
